import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { RoleMemberPostModel } from 'src/app/ViewModel/RoleMemberPostModel';
import { RestApiService } from '../rest-api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from '../Common.service';
import { EncryptDecryptService } from '../encrypt-decrypt.service';


@Injectable({
	providedIn: 'root'
})
export class MemberRoleLinkService {

	private readonly membersListUrl = 'ProjectMembersLink/GetMembersAgainstProjectBusinessGroup';
	private readonly mappedMemberRoleGetUrl = 'RoleMembersLink/GetRoleMembers';
	private readonly memberRoleMapUrl = 'RoleMembersLink/PostRoleMembers';
	private readonly DownloadMemberRoleExcelTemplateUrl = '/RoleMembersLink/DownloadRoleMemberTemplate';
	private readonly UploadMemberRoleExcelTemplateUrl = '/RoleMembersLink/UploadRoleMemberTemplate';
	private readonly CheckRoleMemberWFAssignmentUrl = 'RoleMembersLink/CheckRoleMemberWFAssignment';

	constructor(private restApiService: RestApiService, private commonService: CommonService, private encryptDecryptService: EncryptDecryptService, private http: HttpClient,) { }

	/**
	 * Get project members list
	 * @param projectId 
	 * @param groupId 
	 */
	getMembersList(projectId: number, groupId: number) {
		return this.restApiService.new_POST(this.membersListUrl, { projectId, groupId });
	}

	/**
	 * Get already mapped Role Members
	 * @param projectId 
	 * @param groupId 
	 */
	getMappedRoleMembers(projectId: number, groupId: number) {
		return this.restApiService.new_POST(this.mappedMemberRoleGetUrl, { projectId, groupId });
	}

	/**
	 * Save mapped Members-Role
	 * @param reqData 
	 */
	mapMemberRoles(reqData: RoleMemberPostModel) {
		return this.restApiService.new_POST(this.memberRoleMapUrl, reqData);
	}

	CheckRoleMemberWFAssignment(reqData: RoleMemberPostModel) {
		return this.restApiService.new_POST(this.CheckRoleMemberWFAssignmentUrl, reqData);
	}

	/**
	 * Download project members list
	 * @param projectId 
	 * @param groupId 
	 * @param dedDescription 
	 */
	GetMemberRoleExcelTemplate(projectId: number, groupId: number, dedDescription: string): Observable<Blob> {
		let _apiURL = environment.uriHost + this.DownloadMemberRoleExcelTemplateUrl;
		const headers = {
			'X-Requested-With': 'XMLHttpRequest',
			'Authorization': 'Bearer ' + this.commonService.getJWT(),
			'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
		}
		return this.http.post(_apiURL, { projectId, groupId, dedDescription }, { 'headers': headers, responseType: 'blob' });
	}

	/**
	 * 
	 * @param formData 
	 */
	public UploadMemberRoleExcelTemplate(formData: FormData): Observable<any> {
		let _apiURL = environment.uriHost + this.UploadMemberRoleExcelTemplateUrl;
		const headers = {
			'X-Requested-With': 'XMLHttpRequest',
			'Authorization': 'Bearer ' + this.commonService.getJWT(),
			'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
		}
		return this.http.post<any>(_apiURL, formData, { 'headers': headers });
	}
}
